import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { SideLinks } from 'components/sidelinks/sidelinks';

import { ContracteumLogo } from 'components/contracteum-logo';
import { Icons } from 'components/icons';
import { LinkProps, linksGeneral, linksLimitedUser } from 'config/links';
import { AppRoutes } from 'config/routes';
import { useLimits } from 'hooks';
import { useGetMyCoreWidgetQuery } from 'store/api/organizations';
import styles from './Sidenav.module.scss';

export const SideNav = () => {
  const { t } = useTranslation();
  const { isLoading, isLimitedUser } = useLimits();

  const { data } = useGetMyCoreWidgetQuery(undefined, {
    skip: isLimitedUser || isLoading,
  });

  const flatWidgetLinks: LinkProps[] = useMemo(() => {
    if (!Array.isArray(data) || data?.length === 0) return [];

    return data.reduce<LinkProps[]>((links, widget) => {
      const rawFileds = Array.isArray(widget?.fields) ? widget?.fields : [];

      const sorted = [...rawFileds].sort((a, b) => {
        const ai = Number(a?.viewIndex ?? 0) || 0;
        const bi = Number(b?.viewIndex ?? 0) || 0;
        return ai - bi;
      });

      const subLinks = sorted
        .filter((field) => !!field?.path)
        .map((field) => ({
          label: field?.viewName ?? '',
          path:
            AppRoutes.Dashboard.Home +
            AppRoutes.Dashboard.CustomWidget.Home +
            `?name=${encodeURIComponent(field.path)}`,
        }));

      // Виджет без полей открывать некуда: раньше на нём падал весь сайдбар.
      if (!subLinks.length) return links;

      links.push({
        label: widget?.header,
        path: subLinks[0].path,
        // Пока бэк отдаёт одну группу «Цифровые паспорта» — одна иконка на все её виджеты (KCONT-2338).
        icon: <Icons.DigitalPassports />,
        subLinks,
      });

      return links;
    }, []);
  }, [data]);

  return (
    <aside className={styles.container}>
      <div className={styles.inner}>
        <Link to="/" className={styles.logo}>
          <ContracteumLogo />
        </Link>

        <div className={styles.links}>
          <SideLinks
            links={
              isLimitedUser
                ? linksLimitedUser
                : [...linksGeneral, ...(flatWidgetLinks ?? [])]
            }
          />
          {!isLoading && isLimitedUser && (
            <p className={styles.limitedUser}>{t('Limited user sidenav hint')}</p>
          )}
        </div>
      </div>
    </aside>
  );
};
